let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8OOI7")).then(() => parcelRequire('eEtVH'));